import { useEffect } from 'react'

import { useSetAtom } from 'jotai'

import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { SECONDS } from '@sequencehq/utils/dates'

import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { quoteAnalyticsData } from './atoms'

export const useSyncApiAnalyticsToJotai = () => {
  const ctx = useCubeContext()
  const setAnalyticsData = useSetAtom(quoteAnalyticsData)

  const analyticsQuery = useQuery(
    dashboardv99990101Client.getQuoteAnalytics,
    { quoteId: ctx.queries.rawData.data.common.id },
    { refetchInterval: 30 * SECONDS }
  )

  useEffect(() => {
    if (!analyticsQuery.data) return
    setAnalyticsData(analyticsQuery.data)
  }, [analyticsQuery.data, setAnalyticsData])

  return {
    isLoading: analyticsQuery.isPending,
    isError: analyticsQuery.isError
  }
}
